import styles from "./style.module.css";
import { ReactComponent as SkalebotLogo } from "../../assets/svgIcons/Skalebot.svg";
import { ReactComponent as HumburgerMenu } from "../../assets/navbarIcons/menu.svg";
import { ReactComponent as Cancel } from "../../assets/svgIcons/cancel.svg";
import { SbNavbar } from "../SbNavbar";
import { SlideBar } from "../SlideBar";
import { changeSidebarOpenStatus } from "../../reducers/appSlice";
import { useSelector, useDispatch } from "react-redux";
import { subscription } from "../../reducers/authSlice";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function Header() {
  const { slidebarOpen } = useSelector((state) => state.application);

  const { user, userSub } = useSelector((state) => state.authenticate);
  const location = useLocation();
  const [headerShow, setHeaderShow] = useState(true);
  const [isPro, setIsPro] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userSub"));
    //console.log(userData)
    if (userData) {
      if (userData?.isUserSub && userData?.userSubType === "pro") {
        setIsPro(true);
      }
    } else {
      if (user.companyId) {
        // dispatch(subscription(user.companyId)).then((data)=>{
        //  // console.log(data?.payload?.subscription.subscriptiontype.name)
        //   if (data?.payload?.subscription.subscriptiontype.name==='pro') {
        //     setIsPro(true)
        //   }
        // })
      }
    }
  }, []);

  useEffect(() => {
    if (location.pathname === "/login") {
      setHeaderShow(false);
    } else {
      setHeaderShow(true);
    }
  }, [location]);

  const handleSlide = () => {
    dispatch(changeSidebarOpenStatus());
  };

  return (
    headerShow && (
      <div className="relative" style={{ backgroundColor: "#1C738E" }}>
        <div className={`${styles["header"]} w-11 py-2 m-auto`}>
          <div className="flex justify-content-between align-items-center w-full h-full">
            <div
              className="w-15rem h-full "
              style={{ boxSizing: "border-box", minWidth: "150px" }}
            >
              <div
                style={{ boxSizing: "border-box", maxHeight: "65px" }}
                className="flex align-items-center  "
              >
                <SkalebotLogo className={`${styles["logo-css"]}`} />

                <span style={{ marginLeft: "10px", marginTop: "12px" }}>
                  ADMIN
                </span>
              </div>
            </div>

            <div className="flex align-items-center gap-6">
              <div className={`${styles["desktop-nav"]}`}>
                <SbNavbar />
              </div>
              {slidebarOpen ? (
                <Cancel
                  className="cursor-pointer w-2rem"
                  onClick={handleSlide}
                />
              ) : (
                <HumburgerMenu
                  className="cursor-pointer w-2rem"
                  onClick={handleSlide}
                />
              )}
            </div>
          </div>
        </div>
        <SlideBar />
      </div>
    )
  );
}

export default Header;
